import { render, staticRenderFns } from "./ListaPreciosVentaUpdate.vue?vue&type=template&id=481cda58&scoped=true&"
import script from "./ListaPreciosVentaUpdate.vue?vue&type=script&lang=js&"
export * from "./ListaPreciosVentaUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ListaPreciosVentaUpdate.vue?vue&type=style&index=0&id=481cda58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481cda58",
  null
  
)

export default component.exports